<template>
	<div class="pt210 section page-mypage mb32">
		<breadcrumb :decriptPage="$t('pt210.labels.title')"></breadcrumb>
		<h2>
			<!-- マイページ -->
			{{$t("pt210.labels.title")}}
		</h2>
		<message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="pt210_PART"/>

		<div class="section-inner">
			<h3>{{$t('pt210.labels.title')}}</h3>
			
			<!-- 隠し項目 -->
			<div style="display:none;">
				<span id="server_lbl">{{$t('pt210.labels.server')}}</span>
				<span id="water_lbl">{{$t('pt210.labels.water')}}</span>
				<span id="present_lbl">{{$t('pt210.labels.present')}}</span>
			</div>

			<!-- 説明文１-->
			<div v-html="descriptionInfo['1']"></div>
			<ul id="quick-nav-list" class="mb32">
				<!-- ご注文手続きへ -->
				<li id="quick-nav-regi">
					<button class="submit-button decision" @click="doOrder">{{$t('pt180.buttons.orderProcedure')}}</button>
				</li>
			</ul>

			<div class="serverImg" @error="getErrImage"></div>
			<div class="group-box">
				<ul class="item-list">
					<li v-for="(product, index) in pt210Init.productList1" :key="index">
						<div style="position:relative;" v-if="product.S_ITEM_CD != null" class="grid-link">
							<img class="mb08" style="width:100%; height:142px;" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
							<!-- 商品名＋キャッチコピー -->
							<span class="item-list-detail">
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_PRE}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.WEB_ITEM_NM}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_SUF}}
								</strong>
							</span>
							<div class="pro-details" v-show="false">
								<span :href="'./' + 'PG010MainPage?pageNo=3&sItemNo=' + product.S_ITEM_CD">{{$t('pt110.labels.toDetail')}}</span>
							</div>
							<!-- 発売日 -->
							<div class="mb05" v-if="product.YOYAKU_ITEM_FLG == 1">
								{{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}
							</div>
							<div class="mb05" v-show="false">
								<!-- 税込金額 -->
								<span class="price" v-if="product.TAX_KBN == '1'">
									{{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- 税抜金額 -->
								<span class="price" v-else>
									{{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- (税込) -->
								<span class="price-tax" v-if="product.TAX_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
								<!-- (税抜) -->
								<span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
							</div>
							<div v-show="false">
								<span class="clearfix uketori_icon"></span>
								<template v-if="product.HANBAI_FLG == 1">
									<template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
										<div class="">
											<template v-if="product.ZAIKO_QTY == '9999999'">
												<!-- 入荷待ち予約注文可 -->
												<span style="font-size: 11px;">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.availableForBackorderPreorderAvailable')}}</span>
											</template>
											<template v-else>
												<!-- 在庫数表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<!-- 在庫数 -->
													<span>{{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}</span>
												</template>
												<!-- 在庫状態表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<template v-if="product.ZAIKO_DISP_WAY_KBN == '3'"><br></template>
													<!-- 在庫なし -->
													<template v-if="product.ZAIKO_QTY <= 0">
														<span v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</span>
													</template>
													<!-- 残りわずか -->
													<template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
														<span v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</span>
													</template>
													<template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
														<!-- あり -->
														<span v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</span>
													</template>
												</template>
											</template>
										</div>
									</template>
								</template>
								<template v-if="icon_flg1(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg1(product)}}</font>
								</template>
								<template v-if="icon_flg2(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg2(product)}}</font>
								</template>
								<template v-if="icon_flg3(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg3(product)}}</font>
								</template>
							</div>

							<!--<span class="clearfix uketori_icon"> -->
								<br>
								<div v-for="(kbnMap, indx) in pt210Init.uketoriServiceKbnList" :key="indx" v-show="false">
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[0].MARK_NM}}可</font>
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">
												{{pt210Init.uketoriServiceKbn[1].MARK_NM}}可
											</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_logo.gif" alt="郵便局窓口受取">
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[2].MARK_NM}}可</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_hako_logo.gif" alt="はこぽす">
										</span>
									</template>
								</div>
							<!--</span> -->

							<div class="PT210_itemQty" v-show="true">
								<!-- 数量： -->
								<span>
									<!--{{$t('pt110.labels.quantity')}}: -->
									<select v-model="product.QTY" class="col form-control form-control-sm">
										<option v-for="(item, KEY) in pt210Init.serverQtyList" :key="KEY" :value="item.KEY">
											{{item.VALUE}}
										</option>
									</select>
								</span>
							</div>
						</div>

						<div class="PT210_itemAvailable" style="vertical-align:top;margin-bottom: 5px !important;" v-show="false">
							<!--<input v-if="product.ZAIKO_QTY == 0" type="button" class="cart_order_disabled" /> -->
							<button v-if="product.ZAIKO_QTY == 0" disabled class="cart_order_disabled" >
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
							<!--<input v-else type="button" class="cart_order" @click="pt110doOrder(product)" /> -->
							<button v-else class="btn-success" @click="pt110doOrder(product)">
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
						</div>
					</li>
				</ul>
			</div>
			<div class="nextBlueImg" @error="getErrImage"></div>

			<div class="waterImg" @error="getErrImage"></div>
			<div class="group-box">
				<ul class="item-list">
					<li v-for="(product, index) in pt210Init.productList2" :key="index">
						<div style="position:relative;" v-if="product.S_ITEM_CD != null" class="grid-link">
							<img class="mb08" style="width:100%; height:142px;" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">
							<!-- 商品名＋キャッチコピー -->
							<span class="item-list-detail">
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_PRE}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.WEB_ITEM_NM}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_SUF}}
								</strong>
							</span>
							<div class="pro-details" v-show="false">
								<span :href="'./' + 'PG010MainPage?pageNo=3&sItemNo=' + product.S_ITEM_CD">{{$t('pt110.labels.toDetail')}}</span>
							</div>
							<!-- 発売日 -->
							<div class="mb05" v-if="product.YOYAKU_ITEM_FLG == 1">
								{{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}
							</div>
							<div class="mb05" v-show="false">
								<!-- 税込金額 -->
								<span class="price" v-if="product.TAX_KBN == '1'">
									{{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- 税抜金額 -->
								<span class="price" v-else>
									{{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- (税込) -->
								<span class="price-tax" v-if="product.TAX_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
								<!-- (税抜) -->
								<span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
							</div>
							<div v-show="false">
								<span class="clearfix uketori_icon"></span>
								<template v-if="product.HANBAI_FLG == 1">
									<template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
										<div class="">
											<template v-if="product.ZAIKO_QTY == '9999999'">
												<!-- 入荷待ち予約注文可 -->
												<span style="font-size: 11px;">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.availableForBackorderPreorderAvailable')}}</span>
											</template>
											<template v-else>
												<!-- 在庫数表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<!-- 在庫数 -->
													<span>{{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}</span>
												</template>
												<!-- 在庫状態表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<template v-if="product.ZAIKO_DISP_WAY_KBN == '3'"><br></template>
													<!-- 在庫なし -->
													<template v-if="product.ZAIKO_QTY <= 0">
														<span v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</span>
													</template>
													<!-- 残りわずか -->
													<template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
														<span v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</span>
													</template>
													<template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
														<!-- あり -->
														<span v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</span>
													</template>
												</template>
											</template>
										</div>
									</template>
								</template>
								<template v-if="icon_flg1(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg1(product)}}</font>
								</template>
								<template v-if="icon_flg2(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg2(product)}}</font>
								</template>
								<template v-if="icon_flg3(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg3(product)}}</font>
								</template>
							</div>

							<!--<span class="clearfix uketori_icon"> -->
								<br>
								<div v-for="(kbnMap, indx) in pt210Init.uketoriServiceKbnList" :key="indx" v-show="false">
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[0].MARK_NM}}可</font>
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">
												{{pt210Init.uketoriServiceKbn[1].MARK_NM}}可
											</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_logo.gif" alt="郵便局窓口受取">
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[2].MARK_NM}}可</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_hako_logo.gif" alt="はこぽす">
										</span>
									</template>
								</div>
							<!--</span> -->

							<div class="PT210_itemQty" v-show="true">
								<!-- 数量： -->
								<span>
									<!--{{$t('pt110.labels.quantity')}}: -->
									<select v-model="product.QTY" class="col form-control form-control-sm">
										<option v-for="(item, KEY) in pt210Init.waterQtyList" :key="KEY" :value="item.KEY">
											{{item.VALUE}}
										</option>
									</select>
								</span>
							</div>
						</div>

						<div class="PT210_itemAvailable" style="vertical-align:top;margin-bottom: 5px !important;" v-show="false">
							<!--<input v-if="product.ZAIKO_QTY == 0" type="button" class="cart_order_disabled" /> -->
							<button v-if="product.ZAIKO_QTY == 0" disabled class="cart_order_disabled" >
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
							<!--<input v-else type="button" class="cart_order" @click="pt110doOrder(product)" /> -->
							<button v-else class="btn-success" @click="pt110doOrder(product)">
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
						</div>
					</li>
				</ul>
			</div>
			<div class="nextBlueImg" @error="getErrImage"></div>

			<div class="presentImg" @error="getErrImage"></div>
			<div class="present-group-box">
				<ul class="item-list">
					<li v-for="(product, index) in pt210Init.presentList" :key="index">
						<div style="position:relative;" v-if="product.S_ITEM_CD != null" class="grid-link">
							<img class="mb08" style="width:100%; height:142px;" :src="product.IMG_URL1" alt="product.THUMBNAIL_DETAIL" @error="getErrImage">

							<!-- 商品名＋キャッチコピー -->
							<span class="item-list-detail">
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_PRE}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									<input type="radio" :id="'AgreeFlag_'+index" :name="'AgreeFlag'+index" :value="product.S_ITEM_CD" v-model="presentItem">
									{{product.WEB_ITEM_NM}}
								</strong>
								<strong class="mb05 webNm" style="visibility: visible;">
									{{product.CATCH_COPY_SUF}}
								</strong>
							</span>
							<div class="pro-details" v-show="false">
								<span :href="'./' + 'PG010MainPage?pageNo=3&sItemNo=' + product.S_ITEM_CD">{{$t('pt110.labels.toDetail')}}</span>
							</div>
							<!-- 発売日 -->
							<div class="mb05" v-if="product.YOYAKU_ITEM_FLG == 1">
								{{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}
							</div>
							<div class="mb05" v-show="false">
								<!-- 税込金額 -->
								<span class="price" v-if="product.TAX_KBN == '1'">
									{{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- 税抜金額 -->
								<span class="price" v-else>
									{{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
								</span>
								<!-- (税込) -->
								<span class="price-tax" v-if="product.TAX_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
								<!-- (税抜) -->
								<span class="price-tax" v-else>{{$t('common.labels.excludingtax')}}</span>
							</div>
							<div v-show="false">
								<span class="clearfix uketori_icon"></span>
								<template v-if="product.HANBAI_FLG == 1">
									<template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
										<div class="">
											<template v-if="product.ZAIKO_QTY == '9999999'">
												<!-- 入荷待ち予約注文可 -->
												<span style="font-size: 11px;">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.availableForBackorderPreorderAvailable')}}</span>
											</template>
											<template v-else>
												<!-- 在庫数表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<!-- 在庫数 -->
													<span>{{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}</span>
												</template>
												<!-- 在庫状態表示、両方表示の場合 -->
												<template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
													<template v-if="product.ZAIKO_DISP_WAY_KBN == '3'"><br></template>
													<!-- 在庫なし -->
													<template v-if="product.ZAIKO_QTY <= 0">
														<span v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</span>
													</template>
													<!-- 残りわずか -->
													<template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
														<span v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</span>
													</template>
													<template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
														<!-- あり -->
														<span v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</span>
														<span v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</span>
													</template>
												</template>
											</template>
										</div>
									</template>
								</template>
								<template v-if="icon_flg1(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg1(product)}}</font>
								</template>
								<template v-if="icon_flg2(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg2(product)}}</font>
								</template>
								<template v-if="icon_flg3(product) != ''">
									<font color="gold" style="font-size:11px;">★</font>
									<font color="#ff0033" style="font-size:11px;">{{icon_flg3(product)}}</font>
								</template>
							</div>

							<!--<span class="clearfix uketori_icon"> -->
								<br>
								<div v-for="(kbnMap, indx) in pt210Init.uketoriServiceKbnList" :key="indx" v-show="false">
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[0].MARK_NM}}可</font>
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">
												{{pt210Init.uketoriServiceKbn[1].MARK_NM}}可
											</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_logo.gif" alt="郵便局窓口受取">
										</span>
									</template>
									<template v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
										<span class="mr05">
											<font color="gold" style="font-size:11px;">★</font>
											<font color="#ff0033" style="font-size:11px;">{{pt210Init.uketoriServiceKbn[2].MARK_NM}}可</font>
											<img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_hako_logo.gif" alt="はこぽす">
										</span>
									</template>
								</div>
							<!--</span> -->
						</div>

						<div class="PT210_itemAvailable" style="vertical-align:top;margin-bottom: 5px !important;" v-show="false">
							<!--<input v-if="product.ZAIKO_QTY == 0" type="button" class="cart_order_disabled" /> -->
							<button v-if="product.ZAIKO_QTY == 0" disabled class="cart_order_disabled" >
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
							<!--<input v-else type="button" class="cart_order" @click="pt110doOrder(product)" /> -->
							<button v-else class="btn-success" @click="pt110doOrder(product)">
								<!-- カートに入れる -->
								{{$t('pt110.buttons.addToCart')}}
							</button>
						</div>
					</li>
				</ul>
			</div>
			<div class="nextPinkImg" @error="getErrImage"></div>

			<div class="mb32">
				<button class="submit-button decision" @click="doOrder">{{$t('pt180.buttons.orderProcedure')}}</button>
			</div>
		</div>
	</div>
</template>
<script>
	/* 
	* Import libs and componnents
	*/
	import common from "assets/js/common";
	import axios from "assets/js/request";
	import InputCheck from "components/InputCheck";
	import InputNumber from 'components/InputNumber';
	import Message from 'components/MessageEcSite';
	import SiteConstants from 'assets/const/SiteConstants.json';
	import Breadcrumb from "../commonParts/Breadcrumb.vue";

	export default {
		/* 
		* Name of component
		*/
		name: "pt210ChukyoMultiOrderParts",
		props:{
			ptInitData: {
				type: Object,
				default: null,
			},
		},
		components: {
			InputCheck,
			InputNumber,
			Message,
			Breadcrumb
		},
		data() {
			return {
				kingakuStr:null,
				descriptionInfo: {},
				pt210Init: {
					productList1: [],
					productList2: [],
					presentList: []
				},
				pt210ChukyoMultiOrderPartsReqModel: {
					model:[],
					qyts:[],
					index:null
				},
				priceItem:[],
				presentItem:null,
				lengthRowAdd:10,
				rowIndex:null,
				listIdErr:[],
				listMessValid:[],
				mapMessValid:[],
				SiteConstants:SiteConstants,
				pt210_PART:'pt210',
				site:""
			}
		},
		mounted() {
			var _this = this;
			_this.site = _this.$router.history.current.fullPath.split("/")[1];

			if (_this.ptInitData){
				_this.pt210Init = _this.ptInitData;
				var presentList = _this.pt210Init.presentList;

				for(var i in presentList) {
					if (presentList[i].QTY > 0) {
						_this.presentItem = presentList[i].S_ITEM_CD;
					}
				}

				var zeiKbnNm=null;
				if (_this.ptInitData.zeiKbn == "1") {
					// (税込)
					zeiKbnNm = +_this.$i18n.t('common.labels.taxincluded');
				} else {
					// (税抜)
					zeiKbnNm = _this.$i18n.t('common.labels.excludingtax');
				}
				// 項目説明文
				_this.descriptionInfo = _this.ptInitData.descriptionInfo;
				// 金額
				_this.kingakuStr = _this.$i18n.t('common.labels.kingakuStr')+ zeiKbnNm;

			}else{
				// eslint-disable-next-line
				axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT210 + _this.$UrlConstants.DO_INIT).then(function(response) {
					_this.pt210Init = response.data;
					var presentList = _this.pt210Init.presentList;

					for(var i in presentList) {
						if (presentList[i].QTY > 0) {
							_this.presentItem = presentList[i].S_ITEM_CD;
						}
					}

					var zeiKbnNm=null;
					if (response.data.zeiKbn == "1") {
						// (税込)
						zeiKbnNm = +_this.$i18n.t('common.labels.taxincluded');
					} else {
						// (税抜)
						zeiKbnNm = _this.$i18n.t('common.labels.excludingtax');
					}
					// 項目説明文
					_this.descriptionInfo = response.data.descriptionInfo;
					// 金額
					_this.kingakuStr = _this.$i18n.t('common.labels.kingakuStr')+ zeiKbnNm;

				}).catch(function(error) {
					common.errorAPI(error);
				});
			}
		},
		methods: {
			icon_flg1: function(product) {
				if (product.ITEM_STATUS1 == '0') {
					return product.ICON_NM1;
				} else {
					return "";
				}
			},
			icon_flg2: function(product) {
				if (product.ITEM_STATUS2 == '0') {
					return product.ICON_NM2;
				} else {
					return "";
				}
			},
			icon_flg3: function(product) {
				if (product.ITEM_STATUS3 == '0') {
					return product.ICON_NM3;
				} else {
					return "";
				}
			},
			redirect:function(pageNo) {
				console.log(pageNo);
				var _this = this;
				common.clearMessage(_this.listIdErr,"","pt210")
				_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: pageNo}});
			},
			//doAjax item
			doAjax: function(index) {
				var _this = this;
				_this.pt210ChukyoMultiOrderPartsReqModel.index = index;
				_this.$emit("event-loading", true);
				axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT210 + _this.$UrlConstants.DO_AJAX,_this.pt210ChukyoMultiOrderPartsReqModel).then(function(response) {
					_this.pt210ChukyoMultiOrderPartsReqModel.model = response.data.reqModel.model;
					_this.pt210ChukyoMultiOrderPartsReqModel.qyts = response.data.reqModel.qyts;
					if (_this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk!='' && (response.data.reqModel.qyts[index] == 0 || response.data.reqModel.qyts[index] == null)) {
						_this.pt210ChukyoMultiOrderPartsReqModel.qyts[index] = 1;
						_this.priceItem[index] =_this.pt210ChukyoMultiOrderPartsReqModel.qyts[index] * _this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk;
						_this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk = response.data.reqModel.model[index].saleZeiKTnk;
					} else if (_this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk!='' && (response.data.reqModel.qyts[index] != 0 || response.data.reqModel.qyts[index] != null)) {
						_this.priceItem[index] =_this.pt210ChukyoMultiOrderPartsReqModel.qyts[index] * _this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk;
						_this.pt210ChukyoMultiOrderPartsReqModel.model[index].saleZeiKTnk = response.data.reqModel.model[index].saleZeiKTnk;
					} else {
						_this.pt210ChukyoMultiOrderPartsReqModel.qyts[index] = null;
						_this.priceItem[index] ="";
					}
					_this.$emit("event-loading", false);
				}).catch(function(error) {
					_this.$emit("event-loading", false);
					common.errorAPI(error);
				});
			},
			formatPrice: function(value) {
				return common.formatPrice(value);
			},
			//order item
			doOrder : function() {
				var _this = this;
				_this.addRow();
				common.clearMessageEcSite(_this.listIdErr,"pt210")
				_this.$emit("event-loading", true);
				axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT210 + _this.$UrlConstants.DO_ORDER,_this.pt210ChukyoMultiOrderPartsReqModel).then(function(response) {
					if (response.data.status == "OK") {
						_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}, params: {backPageNo:6}});
					}
					_this.$emit("event-loading", false);
				}).catch(function(error) {
					_this.$emit("event-loading", false);
					if (error != null && error != undefined) {
						_this.isModalShow = false;
						if (error.response != null && error.response != undefined) {
							if (406 == error.response.status) {
								var resultValid = common.excuteValidationEcSite(error, _this.PT210_PART);
								if (resultValid) {
									_this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
									_this.listMessValid = resultValid.msgList;
									_this.mapMessValid = resultValid.mapMsg;
								}
							} else {
								common.errorAPI(error);
							}
						}
					}
					common.scrollTop();
				});
			},
			/**
			 * exec load url default when load main image is error
			 * @param {Any} event, event exec error
			 */
			getErrImage(event) {
				//get image default
				event.target.src = common.getImgDefault();
			},
			//add row 
			addRow: function () {
				var _this = this;
				try {
					var item = {};
					var qty = "";
					var productList = _this.pt210Init.productList1.concat(_this.pt210Init.productList2);
					var presentList = _this.pt210Init.presentList;

					// 配列を初期化
					_this.pt210ChukyoMultiOrderPartsReqModel.model.splice(0, _this.pt210ChukyoMultiOrderPartsReqModel.model.length);
					_this.pt210ChukyoMultiOrderPartsReqModel.qyts.splice(0, _this.pt210ChukyoMultiOrderPartsReqModel.qyts.length);

					for (var i in productList) {
						item = {
							listNo:productList[i].LIST_NO,
							itemNo:productList[i].S_ITEM_CD,
							itemNm:"",
							wariPrice:"",
							saleZeiKTnk:"",
							ecSaleTanka:"",
							bunruiBigCd:productList[i].BUNRUI_BIG_CD
						};

						qty = productList[i].QTY;
						if(qty == null || qty == "") {
							qty = 0;
						}

						if (qty > 0) {
							_this.pt210ChukyoMultiOrderPartsReqModel.model.push(item);
							_this.pt210ChukyoMultiOrderPartsReqModel.qyts.push(qty);
						}
					}
					for (var j in presentList) {
						if (_this.presentItem == presentList[j].S_ITEM_CD) {
							item = {
								listNo:presentList[j].LIST_NO,
								itemNo:presentList[j].S_ITEM_CD,
								itemNm:"",
								wariPrice:"",
								saleZeiKTnk:"",
								ecSaleTanka:"",
								bunruiBigCd:presentList[j].BUNRUI_BIG_CD
							};

							_this.pt210ChukyoMultiOrderPartsReqModel.model.push(item);
							_this.pt210ChukyoMultiOrderPartsReqModel.qyts.push(1);
						}
					}
				} catch(e) {
					console.log(e);
				}
			},
		},
		updated: function() {
			common.setFocus();
		}
	}
</script>
